/**
 * A set of error codes for AppletHost specific errors
 * @enum {string}
 */
export const AppletHostErrorCode = {
    /** The current version's Applet Host is already installed */
    DUPLICATE_HOST_OF_CURRENT_VERSION: 'duplicate-host-of-current-version',

    /** The previous version's Applet Host is already installed */
    DUPLICATE_HOST_OF_PREVIOUS_VERSION: 'duplicate-host-of-previous-version',

    /** Applet tagName is already registered with the host */
    DUPLICATE_TAG_NAME: 'duplicate-tag-name',

    /** The application hasn't implemented this optional applet host feature */
    FEATURE_NOT_SUPPORTED: 'feature-not-supported',

    /** The duration of the exceeds the limit supported by the host application */
    MAX_DATE_RANGE_DURATION_EXCEEDED: 'max-date-range-duration-exceeded',

    /** The number of inputs exceeds the limit supported by the host application */
    MAX_INPUT_LIMIT_EXCEEDED: 'max-input-limit-exceeded',

    /** The current version of AppletHost is not installed yet, but a previous version of AppletHost is already installed */
    CURRENT_VERSION_HOST_NOT_INSTALLED: 'current-version-host-not-installed',

    /** The associated application provider (e.g. coordinated query time) returned invalid output */
    INVALID_OUTPUT_FROM_PROVIDER: 'invalid-output-from-provider',

    /** The associated application repository (e.g. input, date range) return invalid output */
    INVALID_OUTPUT_FROM_REPOSITORY: 'invalid-output-from-repository',

    /** The namespace requested does not exist on the AppletHost */
    UNKNOWN_NAMESPACE: 'unknown-namespace'
};

AppletHostErrorCode.isValid = function isValid(channel) {
    return Object.keys(AppletHostErrorCode).some(key => AppletHostErrorCode[key] === channel);
};
Object.freeze(AppletHostErrorCode);
